<div>
<button class="toggle-thumbnail-button" (click)="toggleThumbnails()">
  <i [ngClass]="isThumbnailsVisible ? 'fa fa-video-camera' : 'fa fa-eye-slash'"></i>
</button>

<div class="camera-view-container" id="isThumbnailsVisible" style="visibility: hidden;">
  <div class="toolbar">
    <!-- Live Button -->
    <button mat-button color="primary" class="live-button">
      <span class="live-indicator"></span> Live
    </button>

    <!-- Camera Dropdown -->
    <mat-form-field appearance="fill" class="camera-dropdown">
      <mat-label>Camera</mat-label>
      <mat-select [(value)]="selectedCamera">
        <mat-option *ngFor="let camera of cameras" [value]="camera.id">
          {{ camera.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Time Range Selection Buttons -->
    <div class="time-range-buttons">
      <button mat-button *ngFor="let range of timeRanges" (click)="selectTimeRange(range)">
        {{ range }}
      </button>
      <!-- <button mat-button [matMenuTriggerFor]="moreTimeMenu">More ▼</button>
      <mat-menu #moreTimeMenu="matMenu">
        <button mat-menu-item *ngFor="let range of moreTimeRanges" (click)="selectTimeRange(range)">
          {{ range }}
        </button>
      </mat-menu> -->
    </div>

    <!-- Date Range Picker -->
    <!-- <mat-form-field class="date-picker">
      <input matInput [matDatepicker]="picker" placeholder="Date Range" [(ngModel)]="selectedDateRange">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker startView="multi-year" (dateChange)="onDateRangeChange()"></mat-datepicker>
    </mat-form-field> -->
  </div>
  
    <!-- Horizontal Scrollable Thumbnails -->
    <!-- <div class="thumbnail-container">
      <button class="scroll-left" (click)="scrollLeft()">&#x276E;</button>
      <div class="thumbnails" #thumbnailContainer>
        <img 
          *ngFor="let thumbnail of thumbnails" 
          [src]="thumbnail.imageUrl" 
          [alt]="thumbnail.time" 
          (click)="openPopup(thumbnail)"
          class="thumbnail"
          [class.selected]="thumbnail.isSelected"
        />
        <div class="thumbnail-overlay">
          <div class="camera-name">{{ 'F3412 Cam 01' }}</div>
          <div class="timestamp">{{ '14-10-2024 3:45pm' }}</div>
        </div>
      </div>
      <button class="scroll-right" (click)="scrollRight()">&#x276F;</button>
    </div> -->
    <div class="main-thumbnail">
      <!-- <button class="scroll-button scroll-left" (click)="scrollLeft()">&#x276E;</button> -->
      <button *ngIf="showLeftNav" class="nav-button left" (click)="scrollLeft()">&#9664;</button>

      <!-- Scrollable container for thumbnails -->
      <div class="thumbnail-scroll-container" #scrollContainer (scroll)="onScroll($event)">
        <div class="thumbnail-container" *ngFor="let thumbnail of thumbnails">
          <div class="thumbnail">
            <img [src]="thumbnail.imageUrl" alt="Thumbnail Image" 
              [class.selected]="thumbnail.isSelected"
              (click)="openPopup(thumbnail)"
              class="thumbnail"/>
            
            <!-- Overlay for Camera Name and Timestamp -->
            <div class="thumbnail-overlay">
              <div class="camera-name">{{ thumbnail?.cameraName }}</div>
              <div class="timestamp">{{ thumbnail?.time }}</div>
            </div>
          </div>
        </div>
        <div class="load-more" #loadMoreObserver></div>
      </div>
    
      <button *ngIf="showRightNav" class="nav-button right" (click)="scrollRight()">&#9654;</button>

      <!-- <button class="scroll-button scroll-right" (click)="scrollRight()">&#x276F;</button> -->
    </div>
    
  </div>
</div>
  <!-- Popup for Thumbnail Details -->
  <!-- <mat-dialog-content *ngIf="selectedThumbnail">
    <h2>{{ selectedThumbnail.time }}</h2>
    <img [src]="selectedThumbnail.imageUrl" alt="Detailed view" />
    <p>{{ selectedThumbnail.details }}</p>
  </mat-dialog-content> -->
  